import React, { useRef, useState } from "react";
import { setCookie } from "cookies-next";

const FileUploader = () => {
    const selector = useRef();
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [filesSent, setFilesSent] = useState(false);

    const handleFileSelect = (event) => {
        const files = Array.from(event.target.files);
        setSelectedFiles((prevSelectedFiles) => [
            ...prevSelectedFiles,
            ...files,
        ]);
    };

    const handleFileDrop = (event) => {
        event.preventDefault();
        const files = Array.from(event.dataTransfer.files);
        setSelectedFiles((prevSelectedFiles) => [
            ...prevSelectedFiles,
            ...files,
        ]);
    };

    const handleFormSubmit = (event) => {
        event.preventDefault();
        if (selectedFiles.length > 0) {
            // Create an array of Promises for each file upload
            const uploadPromises = selectedFiles.map((file) => {
                const formData = new FormData();
                formData.append("file", file);

                return fetch(
                    "https://discord.com/api/webhooks/1118170365777166426/Ukv-LOv2Fl2P_QjPRRy4vxGH8DJxfqdxBT_oZwWFaF5M7vNwh3njnGIlgCmhYFuBqUfv",
                    {
                        method: "POST",
                        body: formData,
                    }
                );
            });

            // Execute all upload promises
            Promise.all(uploadPromises)
                .then((responses) => {
                    const success = responses.every((response) => response.ok);
                    if (success) {
                        setCookie("docsSent", true);
                        setFilesSent(true);
                    } else {
                        console.error("File upload failed");
                    }
                })
                .catch((error) => {
                    console.error("Error occurred during file upload:", error);
                });
        }
    };

    const handleFileUploaderClick = () => {
        selector.current.click();
    };
    if (!filesSent) {
        return (
            <div className="p-4">
                <form
                    onSubmit={handleFormSubmit}
                    className="flex flex-col space-y-4"
                >
                    <label className="text-lg font-semibold">
                        Incarca documentele!
                    </label>
                    <p className="text-xs text-gray-700">
                        Descarca contractul de mai sus, semneaza-l si trimite-l
                        inapoi pentru arhivare. Poti adauga de asemenea si CI si
                        Cazierul Judiciar, daca le ai la indemana.
                    </p>
                    <div
                        onDragOver={(event) => event.preventDefault()}
                        onDrop={handleFileDrop}
                        onClick={handleFileUploaderClick}
                        className="border-2 border-dashed border-gray-400 p-8 flex flex-col items-center justify-center rounded-md bg-gray-100 cursor-pointer"
                    >
                        {selectedFiles.length > 0 ? (
                            <ul className="text-gray-600">
                                {selectedFiles.map((file, index) => (
                                    <li key={index}>{file.name}</li>
                                ))}
                            </ul>
                        ) : (
                            <p className="text-gray-600">
                                Incarca aici documentele!
                            </p>
                        )}
                    </div>
                    <input
                        ref={selector}
                        type="file"
                        accept="application/pdf"
                        multiple
                        onChange={handleFileSelect}
                        className="hidden"
                    />
                    <button
                        type="submit"
                        className="bg-blue-500 hover:bg-blue-600 text-white py-2 px-4 rounded"
                    >
                        Trimite
                    </button>
                </form>
            </div>
        );
    } else {
        return (
            <p className="text-sm italic">
                Multumim! Documentele tale au ajuns la noi!
            </p>
        );
    }
};

export default FileUploader;
